
import { RowsPhotoAlbum } from "react-photo-album";
import "react-photo-album/rows.css";
import img1 from "../src/assets/94A2C538-602A-4BA7-B33F-9A7B13939C46.webp"
import img2 from "../src/assets/708D5176-7E73-43FB-8DBA-7A9A184CFB74.webp"
import img3 from "../src/assets/7138ba54-2aa4-4555-85e1-caa5d17c985d.webp"
import img4 from "../src/assets/16185B27-87FD-49B9-8AAE-933C1135C2CB.webp"
import img5 from "../src/assets/15535015-8143-492a-b09e-9053a9feaac9.webp"
import img6 from "../src/assets/20241215_192158_Samantha Rodríguez.webp"
import img7 from "../src/assets/ALMACEN_Julio Meléndez.webp"
import img8 from "../src/assets/b8b7c084-6589-4110-a946-3de47407ec70_Mariana Lima.webp"
import img10 from "../src/assets/e2ef14f2-0e1a-472b-b821-d16fe25fe457_Montserrat Montero.webp"
import img11 from "../src/assets/fce196fc-ba59-413f-ac8b-173a13fcfb4a_Montserrat Montero.webp"
import img13 from "../src/assets/FEA52EE3-4365-485C-B17D-42B59DB36866.webp"
import img14 from "../src/assets/Imagen de WhatsApp 2025-02-13 a las 16.57.15__Ariel Ruiz.webp"
import img15 from "../src/assets/IMG_2327.webp"
import img16 from "../src/assets/IMG_2345.webp"
import img17 from "../src/assets/IMG_2372.webp"
import img18 from "../src/assets/IMG_2413.webp"
import img19 from "../src/assets/IMG_2426.webp"
import img20 from "../src/assets/IMG_2491.webp"
import img21 from "../src/assets/IMG_2774.webp"
import img22 from "../src/assets/IMG_2809.webp"
import img23 from "../src/assets/IMG_2880.webp"
import img24 from "../src/assets/IMG_3530.webp"
import img25 from "../src/assets/IMG_3532.webp"
import img26 from "../src/assets/IMG_3575.webp"
import img27 from "../src/assets/IMG_3576.webp"
import img28 from "../src/assets/IMG_3578.webp"
import img30 from "../src/assets/IMG_3589.webp"
import img31 from "../src/assets/IMG_3594.webp"
import img32 from "../src/assets/IMG_3597.webp"
import img33 from "../src/assets/IMG_3780.webp"
import img34 from "../src/assets/IMG_3812.webp"
import img35 from "../src/assets/IMG_3865.webp"
import img36 from "../src/assets/IMG_3867.webp"
import img37 from "../src/assets/IMG_4221.webp"
import img38 from "../src/assets/IMG_4285.webp"
import img39 from "../src/assets/IMG_4287.webp"
import img40 from "../src/assets/IMG_4288.webp"
import img41 from "../src/assets/IMG_4290.webp"
import img42 from "../src/assets/IMG_4291.webp"
import img43 from "../src/assets/IMG_4292.webp"
import img44 from "../src/assets/IMG_4294.webp"
import img45 from "../src/assets/IMG_4296.webp"
import img46 from "../src/assets/IMG_4299.webp"
import img47 from "../src/assets/IMG_4301.webp"
import img48 from "../src/assets/IMG_4302.webp"
import img49 from "../src/assets/IMG_4304.webp"
import img50 from "../src/assets/IMG_4305.webp"
import img51 from "../src/assets/IMG_4347.webp"
import img52 from "../src/assets/IMG_4349.webp"
import img53 from "../src/assets/IMG_4350.webp"
import img54 from "../src/assets/IMG_4352.webp"
import img55 from "../src/assets/IMG_4353.webp"
import img56 from "../src/assets/IMG_4354.webp"
import img57 from "../src/assets/IMG_4358.webp"
import img58 from "../src/assets/IMG_4359.webp"
import img59 from "../src/assets/IMG_4360.webp"
import img60 from "../src/assets/IMG_4458.webp"
import img61 from "../src/assets/IMG_4463.webp"
import img62 from "../src/assets/IMG_4464.webp"
import img63 from "../src/assets/IMG_4497_Montserrat Montero.webp"
import img64 from "../src/assets/IMG_4918.webp"
import img66 from "../src/assets/IMG_5486.webp"
import img67 from "../src/assets/IMG_5576.webp"
import img68 from "../src/assets/IMG_5660.webp"
import img69 from "../src/assets/IMG_5667.webp"
import img70 from "../src/assets/IMG_5682.webp"
import img71 from "../src/assets/IMG_5715.webp"
import img73 from "../src/assets/IMG_5765.webp"
import img75 from "../src/assets/IMG_5861.webp"
import img76 from "../src/assets/IMG_6097_Montserrat Montero.webp"
import img77 from "../src/assets/IMG_6207.webp"
import img78 from "../src/assets/IMG_6213.webp"
import img79 from "../src/assets/IMG_6223.webp"
import img80 from "../src/assets/IMG_6227.webp"
import img81 from "../src/assets/IMG_6241.webp"
import img82 from "../src/assets/IMG_6263.webp"
import img83 from "../src/assets/IMG_6266.webp"
import img84 from "../src/assets/IMG_6301.webp"
import img85 from "../src/assets/IMG_6317.webp"
import img86 from "../src/assets/IMG_6330.webp"
import img87 from "../src/assets/IMG_6356.webp"
import img88 from "../src/assets/IMG_6477.webp"
import img90 from "../src/assets/IMG_6526_Montserrat Montero.webp"
import img91 from "../src/assets/IMG_6542.webp"
import img92 from "../src/assets/IMG_6682.webp"
import img93 from "../src/assets/IMG_6898.webp"
import img94 from "../src/assets/IMG_6937.webp"
import img95 from "../src/assets/IMG_7223.webp"
import img96 from "../src/assets/IMG_7365.webp"
import img97 from "../src/assets/IMG_8050.webp"
import img98 from "../src/assets/IMG-20230821-WA0342_Rubén Hernández.webp"
import img99 from "../src/assets/IMG-20240130-WA0514_Rubén Hernández.webp"
import img100 from "../src/assets/IMG-20240214-WA0812_Rubén Hernández.webp"
import img101 from "../src/assets/IMG-20240215-WA0497_Rubén Hernández.webp"
import img102 from "../src/assets/IMG-20250213-WA0619_Samantha Rodríguez.webp"
import img103 from "../src/assets/NAVIDAD 2023 RRSS_1.webp"
import img104 from "../src/assets/Tarjetas TL Tragaluz.webp"
import img105 from "../src/assets/Tragaluz_alonso.webp"
import img106 from "../src/assets/Tragaluz_becarias charlie.webp"
import img107 from "../src/assets/Tragaluz_Dani.webp"
import img108 from "../src/assets/Tragaluz_Esmeralda.webp"
import img109 from "../src/assets/Tragaluz_Janine.webp"
import img110 from "../src/assets/Tragaluz_Juan.webp"
import img111 from "../src/assets/Tragaluz_marianita.webp"
import img112 from "../src/assets/Tragaluz_Montse.webp"
import img113 from "../src/assets/Tragaluz_omouri-rob-quique.webp"
import img114 from "../src/assets/Tragaluz_ramiro-ale.webp"
import img115 from "../src/assets/Tragaluz_Rebe-Cons.webp"
import img116 from "../src/assets/Tragaluz_sam y alexis.webp"
import img117 from "../src/assets/Tragaluz_sam-marlen-charlie.webp"
import img119 from "../src/assets/5b6b2c4c-b6ee-40e2-84d7-974f61ca78fd.webp"
import img120 from "../src/assets/7c199732-de63-4211-9e12-e3163e277bfa.webp"
import img121 from "../src/assets/IMG_7551_Mariana Lima.jpeg"
import img122 from "../src/assets/INTEGRANTES TRAFFIC 2009_Leticia Ríos.JPG"

const Collage = () => {

    const photos = [
        {src: img122, width: 70, height: 60 },
        {src: img1, width: 60, height: 60 },
        {src: img2 , width: 60, height: 90 },
        {src: img3, width: 70, height: 60 },
        {src: img4 , width: 60, height: 90 },
        {src: img5, width: 60, height: 60 },
        {src: img6 , width: 60, height: 90 },
        {src: img7, width: 80, height: 60 },
        {src: img8 , width: 100, height: 90 },
        {src: img10 , width: 110, height: 90 },
        {src: img11, width: 60, height: 60 },
        {src: img13, width: 50, height: 60 },
        {src: img14 , width: 60, height: 90 },
        {src: img15, width: 60, height: 60 },
        {src: img16 , width: 80, height: 90 },
        {src: img17, width: 70, height: 60 },
        {src: img18 , width: 60, height: 90 },
        {src: img19, width: 70, height: 60 },
        {src: img20 , width: 60, height: 90 },
        {src: img21, width: 80, height: 60 },
        {src: img22 , width: 80, height: 90 },
        {src: img23, width: 60, height: 60 },
        {src: img24 , width: 60, height: 90 },
        {src: img25, width: 50, height: 60 },
        {src: img26 , width: 80, height: 90 },
        {src: img27, width: 60, height: 60 },
        {src: img28 , width: 70, height: 90 },
        {src: img30 , width: 70, height: 90 },
        {src: img31, width: 50, height: 60 },
        {src: img32 , width: 70, height: 90 },
        {src: img33, width: 60, height: 60 },
        {src: img34 , width: 60, height: 90 },
        {src: img35, width: 50, height: 60 },
        {src: img36 , width: 70, height: 90 },
        {src: img37, width: 60, height: 60 },
        {src: img38 , width: 60, height: 90 },
        {src: img39, width: 50, height: 60 },
        {src: img40 , width: 60, height: 90 },
        {src: img41, width: 40, height: 60 },
        {src: img42 , width: 60, height: 90 },
        {src: img43, width: 40, height: 60 },
        {src: img44 , width: 60, height: 90 },
        {src: img45, width: 50, height: 60 },
        {src: img46 , width: 60, height: 90 },
        {src: img47, width: 50, height: 60 },
        {src: img48 , width: 60, height: 90 },
        {src: img49, width: 50, height: 60 },
        {src: img50 , width: 60, height: 90 }, 
        {src: img51, width: 50, height: 60 }, //Adán
        {src: img52 , width: 60, height: 90 },
        {src: img53, width: 50, height: 60 },
        {src: img54 , width: 70, height: 90 },
        {src: img55, width: 50, height: 60 },
        {src: img56 , width: 60, height: 90 },
        {src: img57, width: 50, height: 60 },
        {src: img58 , width: 70, height: 90 },
        {src: img59, width: 50, height: 60 },
        {src: img60 , width: 70, height: 90 },
        {src: img61, width: 50, height: 60 },
        {src: img62 , width: 70, height: 90 },
        {src: img63, width: 80, height: 60 },
        {src: img64 , width: 70, height: 90 },
        {src: img66 , width: 60, height: 90 },
        {src: img67, width: 50, height: 60 },
        {src: img68 , width: 70, height: 90 },
        {src: img69, width: 50, height: 60 },
        {src: img70 , width: 110, height: 90 },
        {src: img71, width: 60, height: 60 },
        {src: img73, width: 70, height: 60 },
        {src: img75, width: 50, height: 60 },
        {src: img76 , width: 60, height: 90 },
        {src: img77, width: 50, height: 60 },
        {src: img78 , width: 70, height: 90 },
        {src: img79, width: 60, height: 60 },
        {src: img80 , width: 80, height: 90 },
        {src: img81, width: 50, height: 60 },
        {src: img82 , width: 60, height: 90 },
        {src: img83, width: 70, height: 60 },
        {src: img84 , width: 60, height: 90 },
        {src: img85, width: 80, height: 60 },
        {src: img86 , width: 100, height: 90 },
        {src: img87, width: 80, height: 60 },
        {src: img88 , width: 60, height: 90 },
        {src: img90 , width: 60, height: 90 },
        {src: img91, width: 80, height: 60 },
        {src: img92 , width: 60, height: 90 },
        {src: img93, width: 50, height: 60 },
        {src: img94 , width: 60, height: 90 },
        {src: img95, width: 80, height: 60 },
        {src: img96 , width: 130, height: 90 },//Arley
        {src: img97, width: 80, height: 60 },
        {src: img98 , width: 130, height: 90 },
        {src: img99 , width: 60, height: 90 },
        {src: img100, width: 80, height: 60 },
        {src: img101 , width: 110, height: 90 },
        {src: img102, width: 80, height: 60 },
        {src: img103 , width: 80, height: 90 },
        {src: img104, width: 80, height: 60 },
        {src: img105 , width: 70, height: 90 },
        {src: img106, width: 50, height: 60 },
        {src: img107 , width: 60, height: 90 },
        {src: img108, width: 40, height: 60 },
        {src: img109 , width: 70, height: 90 },
        {src: img110, width: 50, height: 60 },
        {src: img111 , width: 60, height: 90 },
        {src: img112, width: 50, height: 60 },
        {src: img113 , width: 70, height: 90 },
        {src: img114, width: 50, height: 60 },
        {src: img115 , width: 70, height: 90 },
        {src: img116 , width: 70, height: 90 },
        {src: img117, width: 50, height: 60 },
        {src: img119 , width: 90, height: 90 },
        {src: img120, width: 80, height: 60 },
        {src: img121, width: 70, height: 60 },
    ]

    return(
        <div style={{padding:10}}>
            <RowsPhotoAlbum photos={photos} spacing={10} />
        </div>
    )
}

export default Collage;